import React from 'react';
import { CampdeskLogo } from '@/components/svg/CampdeskLogo.tsx';
import { Outlet } from '@tanstack/react-router';

const AuthLayout = () => {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-basic-white p-10 max-md:p-8 max-sm:p-6">
      <div className="flex w-full max-w-[520px] flex-col items-center gap-10">
        <CampdeskLogo />
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
